import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import DefaultMetaTags from '../DefaultMetaTags';
import './Home.css';

const Home: React.FC = () => {
  const { language } = useLanguage();

  return (
    <section id="home" className="hero">
      {/* Add meta tags for homepage */}
      <DefaultMetaTags />

      <div className="hero-content">
        <div className="logo-container">
          <img src="/logo.png" alt="AI Academy Logo" width="300" height="300" />
        </div>

        <h3 className={language === 'ar' ? 'visible' : 'hidden'}>
          تشكيل مبتكري الغد وتمكين محترفي اليوم
        </h3>
        <h3 className={language === 'en' ? 'visible' : 'hidden'}>
          Shaping tomorrow's innovators and empowering today's professionals
        </h3>

        <div className="hero-buttons">
          <a
            href="#about"
            className={`hero-btn ${language === 'ar' ? 'visible' : 'hidden'}`}
          >
            تعرف علينا
          </a>
          <a
            href="#about"
            className={`hero-btn ${language === 'en' ? 'visible' : 'hidden'}`}
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;